import { render } from "./AwardDetailJune2022Page.vue?vue&type=template&id=13df990d"
import script from "./AwardDetailJune2022Page.vue?vue&type=script&lang=js"
export * from "./AwardDetailJune2022Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__